/**
 * The sourceId of a CommerceAdjustment that refers to a reduced Swiss tax
 * rate of (currently) 2.5%.
 */
export const TAX_REDUCED = 'swiss_vat|ch|reduced'
